// #region Imports
import KeyboardTabIcon from "@mui/icons-material/KeyboardTab";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import FeeScheduleCategoryList from "_shared/fee-schedules/categories/_views/fee-schedule-category-list";
import FeeScheduleCategory from "_shared/fee-schedules/categories/fee-schedule-category";
import { FeeScheduleCategoryMaskedCurrency, MaskedFeeSchedule } from "work/_shared/masked-fields";
// #endregion

// #region Styled Components
const Drawer = styled(MuiDrawer)(() => ({
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    marginTop: '64px',
    width: '400px',
    boxSizing: 'border-box',
  },
}));
const FeeCategoryPanel = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "closeAfterTransition"
})<{ open?: boolean }>(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    width: open ? "400px" : 0,
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: open
        ? theme.transitions.easing.easeOut
        : theme.transitions.easing.sharp,
      duration: open
        ? theme.transitions.duration.enteringScreen
        : theme.transitions.duration.leavingScreen,
    }),
  },
}));
const FeeCategoryPanelContainer = styled("div")(() => ({
  flex: 1,
  height: "100%",
}));
const FeeCategoryPanelContent = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  padding: theme.spacing(2),
  width: "400px",
}));
const TitleBar = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row",
  paddingBottom: theme.spacing(1),
}));
// #endregion

// #region Props/Types
type ExistingFeeScheduleCategoryDrawerProps = {
  selectedCategories: Array<FeeScheduleCategory | FeeScheduleCategoryMaskedCurrency> | MaskedFeeSchedule;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onCategoriesSelected: (categories: FeeScheduleCategory[]) => void;
};
// #endregion

export default function ExistingFeeScheduleCategoryDrawer(props: Readonly<ExistingFeeScheduleCategoryDrawerProps>) {
  const {
    selectedCategories,
    isOpen,
    onClose,
    onCategoriesSelected,
  } = props;

  // #region Render
  return (
    <FeeCategoryPanel open={isOpen} anchor="right" variant="persistent" closeAfterTransition={false}>
      <FeeCategoryPanelContainer>
        <FeeCategoryPanelContent>
          <TitleBar>
            <Typography variant="h5">Select Existing Categories</Typography>
            <Tooltip title="Minimize panel">
              <IconButton size="medium" onClick={onClose}>
                <KeyboardTabIcon fontSize="large" />
              </IconButton>
            </Tooltip>
          </TitleBar>
          <FeeScheduleCategoryList
            disabledCategories={selectedCategories}
            onCategoriesSelected={onCategoriesSelected}
          />
        </FeeCategoryPanelContent>
      </FeeCategoryPanelContainer>
    </FeeCategoryPanel>
  );
}
// #endregion
